<template lang="pug">
  .image-links-wrapper(v-if="topLinks")
    Carousel(:controls="false")
      .image-link-box(v-for='(link, index) in topLinks' :key="link.id")
        rogue-link.link(
          :class="{active: isFilterActive(link)}"
          :to="link.link"
          :categoryId="link.id"
        )
          div.link-desc(v-if="link.desc")
            .name-desc
              h4.name {{ __(link.label) }}
              .desc(v-html="link.desc")
              .shop-link {{ __('Shop Now') }}
            img(:src="'https://assets.roguefitness.com/f_auto,q_auto,w_260,h_310,b_rgb:F8F8F8' + link.image" alt="" width="130" height="155" :fetchpriority="index === 0 ? 'high' : undefined")
          div.link-no-desc(v-else)
            .img-box
              img(:src="'https://assets.roguefitness.com/f_auto,q_auto,w_440,h_280,b_rgb:F8F8F8' + link.image" alt="" width="220" height="140" :fetchpriority="index === 0 ? 'high' : undefined")
            .name {{ __(link.label) }}
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { useRoute } from 'vue-router'
import { useRogue } from '@/js/services/Rogue'
import { useCategoryStore } from '@/js/stores/categoryStore'
import { LINKS } from '@/js/stores/category-links'
import type { Category } from '@/js/services/RogueTypes'

type Link = {
  id: string | number,
  filter: string | number
}

const imageLinks = LINKS
const categoryStore = useCategoryStore()
const rogue = useRogue()
const route = useRoute()
const attrs = useAttrs()

const props = defineProps({
  categoryId: {
    type    : Number,
    default : null,
  },
  activeFilters: {
    type    : Array,
    default : () => ([]),
  },
})

const categories = computed<{[key:string]: Category}>(() => categoryStore.categories)

const topLinks = computed(() => {
  const functionalTrainerData = {
    id    : 14591,
    image : '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rig%20and%20Rack%20Category%20Assets/Functional-Trainer-Red_zcupyf.png',
    label : 'Functional Trainers',
    link  : '/strength-equipment/functional-trainers',
    name  : 'Functional Trainers',
  }

  // Filter out 'Rigs' in the 'Rogue Rigs & Racks' category and replace it with 'Functional Trainers'
  if (props.categoryId === 7967 && ['USA', 'CAN'].includes(rogue.site.code)) {
    const rigsAndRacksData = [...categories.value[props.categoryId].topLinks.links.filter((cat: number) => cat.id !== 8193)]
    rigsAndRacksData.push(functionalTrainerData)
    rigsAndRacksData.unshift(rigsAndRacksData.pop())

    return rigsAndRacksData
  }

  return categories.value[props.categoryId].topLinks.links
})

const category = computed<{[key:string]: Category}>(() => (props.categoryId || attrs.category.categoryId ? categories.value[props.categoryId] : false))

function isFilterActive(link: Link) {
  return link.id === props.categoryId || (link.filter && Object.keys(link.filter).every(param => route.query[param] === link.filter[param]))
}
</script>

<style>
.image-links-wrapper .scroller-wrap .scroller .contents {
  padding-bottom: 0;
}
</style>

<style lang="scss" scoped>
.image-links-wrapper {
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-basis: 100% !important;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0px 8px 24px 0;

  .image-link-box {
    @include all-desktop() {
      flex-grow: 1;
      min-width: calc(100%/8);
    }

    @include not-desktop() {
      flex-grow: 0;
    }
  }

  .image-link-box .link {
    background: $color-gray-x-light;
    color: $color-black;
    text-decoration: none;
    font-family: $font-condensed;
  }

  .link.active .link-desc {
    border: 1px solid black;
  }

  .image-link-box .link-desc {
    background: $color-gray-x-light;
    padding: 12px 16px 12px 24px;
    margin: 0 8px 20px 8px;
    min-width: 285px;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .link-desc img {
    max-width: 130px;
  }

  .link-desc .name {
    margin-bottom: 5px;
    font-size: 22px;
  }

  .link-desc .desc {
    font-size: 16px;
  }

  .link-desc .shop-link {
    text-decoration: underline;
    margin-top: 5px;
  }

  .link-no-desc {
    background-color: transparent;
    margin: 0 0 8px 0;
    padding: 8px;
    max-width: 100%;
    width: 100%;
    display: block;
    font-weight: $weight-bold;
  }

  .link-no-desc .name {
    text-align: left;
    margin-top: 5px;
    font-size: 18px;
  }

  .link-no-desc .img-box {
    background-color: $color-gray-x-light;
    text-align: center;
    max-width: 100%;
    padding: 0 12px;
  }

  .link-no-desc .img-box img {
    max-width: 220px;
  }
}

</style>
